import { render, staticRenderFns } from "./dialogLastOrder.vue?vue&type=template&id=5fee8d70"
import script from "./dialogLastOrder.vue?vue&type=script&lang=js"
export * from "./dialogLastOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports